import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { useSetTheme } from "contexts/theme-context";
import { Layout } from "antd";
import React, { useEffect } from "react";
import Footer from "kd/containers/Footer/Footer";
import FrontPage from "./containers/FrontPage/FrontPage";
import NavbarKD from "./components/Nav/Navbar_KD";
import KDEvents from "./containers/Events/Events";
import KDAboutUs from "./containers/AboutUs/AboutUs";
import KDJobPostings from "./containers/JobPostings/JobPostings";
import KDContactUs from "./containers/ContactUs/ContactUs";
import KDSingleEventPage from "./containers/SingleEventPage/SingleEventPage";
import SummerInternshipPage from "./containers/SIP/SummerInternshipPage";

const { Content } = Layout;

function AppKD() {
  const setTheme = useSetTheme();

  useEffect(() => {
    setTheme("kd", true);
  }, [setTheme]);

  return (
    <Router>
      <Layout style={{ background: "var(--neutral-alt)", minHeight: "100vh" }}>
        <NavbarKD />
        <Content>
          <Switch>
            <Route exact path="/kd/">
              <FrontPage />
            </Route>
            <Route path="/kd/events/:id">
              <KDSingleEventPage />
            </Route>
            <Route path="/kd/events/">
              <KDEvents />
            </Route>
            <Route path="/kd/jobs/">
              <KDJobPostings />
            </Route>
            <Route path="/kd/about-us/">
              <KDAboutUs />
            </Route>
            <Route path="/kd/contact-us/">
              <KDContactUs />
            </Route>
            <Route path="/kd/summer-internship-presentasjoner/">
              <SummerInternshipPage />
            </Route>
          </Switch>
        </Content>
        <Footer />
      </Layout>
    </Router>
  );
}

export default AppKD;
